import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), c = /* @__PURE__ */ e("path", {
  fill: "#FFDA44",
  d: "M20 0C12.909 0 6.68 3.69 3.128 9.256l27.122 27.92C36.09 33.683 40 27.299 40 20 40 8.954 31.046 0 20 0Z"
}, null, -1), s = /* @__PURE__ */ e("path", {
  fill: "#0052B4",
  d: "M40 20c0-5.19-1.976-9.916-5.217-13.47v26.94A19.927 19.927 0 0 0 40 20ZM24.983 37.646l2.095-.001.647-1.993.648 1.992h1.051a19.976 19.976 0 0 0 1.867-1.136l-27.8-27.8a20.007 20.007 0 0 0-1.251 2.09l.247.76 2.095-.002-1.694 1.232.648 1.992-1.695-1.23-1.012.736A19.992 19.992 0 0 0 0 20c0 11.046 8.954 20 20 20 2.335 0 4.577-.4 6.66-1.137l-1.677-1.217ZM4.462 19.131l.646-1.993-1.696-1.23 2.095-.002.647-1.993.648 1.992 2.095-.001-1.694 1.232.649 1.992-1.696-1.23-1.694 1.233Zm4.314 4.347.646-1.993-1.695-1.23 2.095-.001.646-1.993.649 1.992 2.095-.001-1.694 1.232.648 1.992-1.695-1.23-1.695 1.232Zm4.315 4.348.646-1.993-1.696-1.23 2.095-.002.646-1.992.649 1.992 2.095-.002-1.694 1.233.649 1.992-1.696-1.23-1.694 1.232Zm6.008 3.116-1.694 1.232.646-1.993-1.695-1.23 2.095-.002.646-1.993.648 1.992h2.095l-1.694 1.232.649 1.992-1.696-1.23Zm2.62 5.58.647-1.993-1.696-1.23 2.095-.002.646-1.993.649 1.992 2.095-.001-1.694 1.232.648 1.992-1.695-1.23-1.695 1.233Z"
}, null, -1), i = [
  n,
  c,
  s
];
function d(r, a) {
  return l(), t("svg", o, [...i]);
}
const _ = { render: d };
export {
  _ as default,
  d as render
};
